import {ENDPOINT_GET_SITE_ASSET_CONFIG} from "../../../util/Constants";
import {getAPIGatewayPostRequest, getNodeId} from "../../../util/Util";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";

let appConfig = {};

async function loadConfig() {
    const baseUrl = window.location.origin;
    appConfig = await fetch(`${baseUrl}/config/config.json`).then((response) => response.json());
}

async function loadSiteConfig() {
    const request = {
        nodeId: getNodeId()
    }
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_SITE_ASSET_CONFIG);
    return await getAPIGatewayDataFromParent(args);
}

function getConfig() {
    return appConfig;
}

export {loadConfig, getConfig, loadSiteConfig};



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/config.js